export const OPENED_TAB_KEY = 'openedTabId';

export const setOpenedTabId = () => {
  localStorage[OPENED_TAB_KEY] = Date.now();
};
